export const SIDE_MENU_BREAKPOINTS = {
  mobile: 1230,
  expanded: 1488,
};
